import axiosIns from '../../../xaxios';
import { obtenerUrlAPIComisiones } from '../utils/funciones';

export default {
  async findProgramasConInscripciones(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones('programas/inscripciones'), opciones);
  },
};
